import * as React from "react";
import * as Modal from "react-modal";
import DatePicker from "react-datepicker";
const Loader = require("react-loader-spinner").default;
import * as moment from "moment";
import { toast } from "react-toastify";

const NEWUSER = {
  id: null,
  name: null,
  email: null,
  followers: 0,
  categoryId: null,
  subCategory: null,
  phone: null,
  birthDate: null,
  city: null,
  socialUrl: null,
  agency: null,
  sex: "male",
  engagementPercentage: null,
  viewsPercentage: null,
  storyPrice: null,
  feedPrice: null,
  type: "instagram",
  teenFollowers: null,
  youngFollowers: null,
  adultFollowers: null,
  israeliPercentage: null,
  fakePercentage: null,
  malePercentage: null,
  femalePercentage: null,
  insurance: null,
  clicks: null,
  password: null
};

export default class Edit extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      newUser: Object.assign({}, NEWUSER),
      newUserModal: false,
      activeUser: null,
      loading: false,
    };
  }

  editUser = (event: any) => {
    let newUser = this.state.newUser;
    newUser[event.target.name] = event.target.value;
    this.setState({ newUser });
  };

  static getDerivedStateFromProps(nextProps: any, prevState: any) {
    if (nextProps.activeUser !== prevState.activeUser)
      return { activeUser: nextProps.activeUser };
    return null;
  }

  componentDidUpdate(nextProps: any, prevState: any) {
    if (
      this.state.activeUser &&
      this.state.activeUser !== prevState.activeUser
    ) {
      this.getUser(this.state.activeUser);
    }
  }

  getUser = (id: number) => {
    this.setState({ loading: true });
    return fetch("users/get", {
      method: "POST",
      body: JSON.stringify({ id }),
    })
      .then((results) => {
        return results.json();
      })
      .then((data) => {
        let user = data.user;
        user.birthDate = user.birthDate
          ? moment(user.birthDate, "YYYY-MM-DD").toDate()
          : "";
        this.setState({
          newUser: user,
          newUserModal: true,
          loading: false,
        });
      })
      .catch((err) => {
        this.setState({ loading: false });
        toast.error(err.message);
      });
  };

  public render() {
    const newUser = this.state.newUser;
    return (
      <div style={{display: "inline-block"}}>
        {this.state.loading && (
          <div className="loading">
            <Loader
              type="Oval"
              className="loader"
              color="#2f98e0"
              height={100}
              width={100}
            />
          </div>
        )}
        <button
          onClick={() => {
            this.setState({
              newUserModal: true,
              newUser: Object.assign({}, NEWUSER),
            });
          }}
        >
          משתמש חדש
        </button>
        <Modal isOpen={this.state.newUserModal} className="newUser-modal">
          <a
            className="fa fa-times"
            onClick={() => {
              this.props.resetActive();
              this.setState({
                newUserModal: false,
              });
            }}
          ></a>
          <div className="scroll">
            <label>שם מלא</label>
            <input
              name="name"
              type="text"
              value={newUser.name || ""}
              onChange={this.editUser.bind(this)}
            />
            <label>אימייל</label>
            <input
              name="email"
              type="text"
              value={newUser.email || ""}
              onChange={this.editUser.bind(this)}
            />
            <label>סיסמה</label>
            <input
              name="password"
              type="password"
              value={newUser.password || ""}
              onChange={this.editUser.bind(this)}
            />
            <label>סוג</label>
            <select
              name="type"
              value={newUser.type || ""}
              onChange={this.editUser.bind(this)}
            >
              <option value="instagram">אינסטגרם</option>
              <option value="facebook">פייסבוק</option>
            </select>
            <label>לינק פרופיל</label>

            <input
              name="socialUrl"
              value={newUser.socialUrl || ""}
              type="text"
              onChange={this.editUser.bind(this)}
            />
            <label>עוקבים</label>

            <input
              name="followers"
              value={newUser.followers || "עוקבים"}
              type="number"
              onChange={this.editUser.bind(this)}
            />
            <label>תאריך לידה</label>

            <DatePicker
              selected={newUser.birthDate || new Date()}
              dateFormat={"dd/MM/yyyy"}
              onChange={(date: any) => {
                newUser.birthDate = date;
                this.setState({ newUser });
              }}
            />
            <label>טלפון</label>

            <input
              name="phone"
              value={newUser.phone || ""}
              type="text"
              onChange={this.editUser.bind(this)}
            />
            <label>הקלקות</label>

            <input
              name="clicks"
              value={newUser.clicks || ""}
              type="text"
              onChange={this.editUser.bind(this)}
            />
            <label>עיר</label>

            <input
              name="city"
              value={newUser.city || ""}
              type="text"
              onChange={this.editUser.bind(this)}
            />
            <label>סוכנות</label>

            <input
              name="agency"
              value={newUser.agency || ""}
              type="text"
              onChange={this.editUser.bind(this)}
            />
            <label>קטגוריה</label>

            <select
              name="categoryId"
              value={newUser.categoryId || "null"}
              onChange={this.editUser.bind(this)}
            >
              <option disabled selected value="null">
                בחר קטגוריה
              </option>
              {this.props.categories.map((category: any, i: number) => {
                return (
                  <option key={i} value={category.id}>
                    {category.title}
                  </option>
                );
              })}
            </select>
            <label>תת קטגוריה</label>

            <input
              name="subCategory"
              value={newUser.subCategory || ""}
              type="text"
              onChange={this.editUser.bind(this)}
            />
            <label>מין</label>

            <select
              name="sex"
              value={newUser.sex || "male"}
              onChange={this.editUser.bind(this)}
            >
              <option value="male">זכר</option>
              <option value="female">נקבה</option>
            </select>
            <label>אחוז מעורבות</label>

            <input
              name="engagementPercentage"
              value={newUser.engagementPercentage || ""}
              type="number"
              onChange={this.editUser.bind(this)}
            />
            <label>אחוז צפיות</label>

            <input
              name="viewsPercentage"
              value={newUser.viewsPercentage || ""}
              type="number"
              onChange={this.editUser.bind(this)}
            />
            <label>מחיר סטורי</label>

            <input
              name="storyPrice"
              value={newUser.storyPrice || ""}
              type="number"
              onChange={this.editUser.bind(this)}
            />
            <label>מחיר פיד</label>

            <input
              name="feedPrice"
              value={newUser.feedPrice || ""}
              type="number"
              onChange={this.editUser.bind(this)}
            />
            <label>עוקבים 18-25</label>

            <input
              name="teenFollowers"
              value={newUser.teenFollowers || ""}
              type="number"
              onChange={this.editUser.bind(this)}
            />
            <label>עוקבים 25-35</label>

            <input
              name="youngFollowers"
              value={newUser.youngFollowers || ""}
              type="number"
              onChange={this.editUser.bind(this)}
            />
            <label>עוקבים 35-45</label>

            <input
              name="adultFollowers"
              value={newUser.adultFollowers || ""}
              type="number"
              onChange={this.editUser.bind(this)}
            />
            <label>אחוז עוקבים ישראלים</label>

            <input
              name="israeliPercentage"
              value={newUser.israeliPercentage || ""}
              type="number"
              onChange={this.editUser.bind(this)}
            />
            <label>אחוז עוקבים מזויפים</label>

            <input
              name="fakePercentage"
              value={newUser.fakePercentage || ""}
              type="number"
              onChange={this.editUser.bind(this)}
            />
            <label>אחוז עוקבים גברים</label>

            <input
              name="malePercentage"
              value={newUser.malePercentage || ""}
              type="number"
              onChange={this.editUser.bind(this)}
            />
            <label>אחוז עוקבים נשים</label>

            <input
              name="femalePercentage"
              value={newUser.femalePercentage || ""}
              type="number"
              onChange={this.editUser.bind(this)}
            />
            <label>קופ״ח</label>

            <input
              name="insurance"
              value={newUser.insurance || ""}
              type="text"
              onChange={this.editUser.bind(this)}
            />
            <button
              className="submit"
              onClick={() => {
                this.props.updateUser(newUser);
                this.setState({ newUserModal: false });
              }}
            >
              שמירה
            </button>
          </div>
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/users/Edit.tsx